import { orderBy } from 'lodash'

export function tablasOrdenadas(state) {
  return orderBy(
    state.tablas,
    'orden'
  )
}
